/**
 * AnswerView — 정답 한 줄(문제 보기 탭 · 분석 카드가 함께 쓴다).
 *
 * 값은 **18px(text-lg)** 이다(오너 지시 2026-08-31 「폰트 사이즈를 키워줘」). 종전 14px 은
 * 곁의 안내문·라벨과 같은 단이라, 이 화면에서 사람이 가장 먼저 찾는 값이 가장 흔한 크기로
 * 서 있었다. 정답은 ④·3·2√5 처럼 짧아 키워도 줄이 밀리지 않는다.
 * '정답 없음'만 종전 크기로 남긴다 — 그건 값이 아니라 **없다는 안내**다.
 *
 * 2026-09-27 ProblemViewTab 에서 꺼냈다 — 분석 카드의 정답 칸을 이 칸과 「동일하게」(오너 지시) 그리려면
 * 같은 부품을 써야 값이 갈리지 않는다.
 */
import { InlineMath } from 'react-katex';
import parseAnswerForDisplay from '../OcrHub/answerLatex';

export default function AnswerView({ value }) {
  const shown = parseAnswerForDisplay(value);
  if (shown.mode === 'empty') return <span className="text-sm text-gray-400">정답 없음</span>;
  if (shown.mode === 'text') return <span className="text-lg font-medium text-gray-900">{shown.value}</span>;
  return (
    <span className="text-lg font-medium text-gray-900">
      <InlineMath
        math={shown.value}
        renderError={() => <code className="rounded bg-gray-100 px-1 text-[0.9em] text-gray-700">{value}</code>}
      />
    </span>
  );
}
